import React, {useState,useEffect } from "react";
import { useTranslation } from "react-i18next";
import { isUserExists } from "../../features/userSlice";
import { useDispatch, useSelector } from 'react-redux';
import {useNavigate } from "react-router-dom";
import { msgAccessPromt } from "../../constant/constant";
import { faMobileScreen } from "@fortawesome/free-solid-svg-icons";
import { AuthLayout, AuthField } from "./AuthLayout";

const Login = () => {
    const { t } = useTranslation();
    const [phone, setPhone] = useState("");
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { isUserLogedIn } = useSelector((state) => state.users);

    const generateToken = () => {
        return `${Date.now()}-${Math.random().toString(36).substring(2, 11)}`;
      };
    const handleSubmit = async(e) => {

        msgAccessPromt({dispatch,msg:'LOADING',error:true});
        if(phone.length!==10){
            msgAccessPromt({dispatch,error:true,msg:t('auth.invalidMobile')});
            return false;
        }

        e.preventDefault();
        let dataSet = new FormData();
        let token = generateToken();
        
        dataSet.append('phone_number',phone);
        dataSet.append('token_id', token);
        localStorage.setItem("phone_number", phone);
        localStorage.setItem("user_token", token);

        try {
            const data = await dispatch(isUserExists(dataSet)).unwrap(); // Unwrap to get the resolved value
            if(data.success){
                msgAccessPromt({dispatch,error:false,msg:t('auth.alreadySignedUp')});
                navigate("/login_mpin");
            }else{
              //  msgAccessPromt({dispatch,error:false,msg:'Enter Otp for Signup !!'});
              msgAccessPromt({dispatch,msg:'LOADING',error:false});
                navigate("/sign-up");

            }
        } catch (error) {
            console.error('API Error:', error);
            msgAccessPromt({dispatch,error:true,msg:t('common.apiError')});

        }
        
    };

    const handleChange = (e) => {
        const value = e.target.value;
        // Allow only digits and restrict to 10 characters
        if (/^\d*$/.test(value) && value.length <= 10) {
            setPhone(value);
        }else{
            msgAccessPromt({dispatch,error:true,msg:t('auth.onlyTenDigits')});
        }
    };
   
    useEffect(()=>{
        if(isUserLogedIn){
            navigate("/home", { replace: true });
        }
    },[isUserLogedIn,navigate]);


    return (
        <AuthLayout icon={faMobileScreen} title={t('auth.enterNumber')} subtitle={t('auth.enterNumberSub')}>
            <AuthField icon={faMobileScreen} type="number" inputMode="numeric" value={phone} onChange={handleChange} placeholder={t('auth.mobilePlaceholder')} />
            <button type="button" onClick={handleSubmit} className="auth-btn">{t('auth.next')}</button>
        </AuthLayout>
    );
};

export default Login;
